import { render, staticRenderFns } from "./FormNewWiedervorlage.vue?vue&type=template&id=7dab5958&scoped=true"
import script from "./FormNewWiedervorlage.vue?vue&type=script&lang=js"
export * from "./FormNewWiedervorlage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab5958",
  null
  
)

export default component.exports